import StepTransfert from 'components/stepTransfert'
import Synthese from 'components/Synthese'
import Benefiaire from 'containers/transfertContainer/beneficiare'
import Montant from 'containers/transfertContainer/montant'
import Paiement from 'containers/transfertContainer/payment'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import UserContext from 'contexts/UserContext'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { tracks } from 'requests/transfer'
import FlecheRetour from '../../assets/arrow-back-navigation.svg'

const TransfertWallet = () => {

  const codeParams = useParams()?.code
  const{user}=useContext(UserContext)
  const navigation = useNavigate()


  const nomstep = ['Montant', 'Bénéficiaire', 'Paiement']
  const {TransferData, setTransferData}=useContext(transferBeneficiaryContext)

  const [trackId, setTrackId] = useState('')
  const [loading, setLoading] = useState(false)
  
  const [numStep, setNumStep] = useState(0)
  const [amountToSend, setAmountToSend] = useState<number>(TransferData?.euroValue || 100)
  const [amountToReceive, setAmountToReceive] = useState<number>(0)
  const [departureCurrencyId, setDepartureCurrencyId] = useState<string>('')
  const [destinationCurrencyId, setDestinationCurrencyId] = useState<string>('')
  const [paymentMode, setPaymentMode] = useState(TransferData?.modeDePaiement || 'cb')
  const [promoCode, setPromoCode] = useState('')
  const [pathCode] = useState<string>('2')
  const [valuePays, setValuePays] = useState({value: 'XOF'})


  const [benificiareId, setBenificiareId] = useState<string>('')
  const [motif, setMotif] = useState<string>('')
  const [idBeneficiary, setIdBeneficiary] = useState('')
  const [selectedBnfList, setSelectedBnfList] = useState('')
 
  
  const [currencyToTND, setCurrencyToTND] = useState(0)
 
    // const [openModalWallt , setOpenModalWallet]= useState(false)
  
  const [com, setCom] = useState<number>(0)
  const [taux, setTaux] = useState<number>(0)
  const [modePay, setModePay] = useState<string>('Wallet')
  
 const functionTracks = async (stepNumber: string) => {
    const id = user?.user?._id
    let dataTracks = {
      label: pathCode === '0' ? 'cash_transfer' : 'bank_transfer',
      step: stepNumber,
      userId: id,
    }

    if (stepNumber !== '0') {
      const newDataTracks = {
        ...dataTracks,
        trackId: trackId,
      }
      dataTracks = newDataTracks
    }
    try {
      const response = await tracks(dataTracks)
      if (response?.success === true) {
        setTrackId(response?.trackId)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }


 useEffect(()=>{

       setTransferData((prev:any)=>({
            ...prev,
           operateurWallet: `${ TransferData?.valuePays==='XOF' ? 'Orange Money Senegal' : ''}` 
        }))
       
 },[TransferData?.valuePays])



  useEffect(() => {
    functionTracks('0')
  }, [])

  return (
   <div className="flex w-full  mb-20  ">
    <div className="flex flex-col px-[140px] 3xl:px-[40px] lg:px-[20px]  w-[70%] 3xl:w-[60%] items-center justify-center xl:w-full lg:mt-[40px] sm:mt-[20px]">

<div className='flex w-full items-center justify-between'>
          <button
              type="button"
              onClick={() => navigation('/')}
              className="hidden lg:block cursor-pointer"
              aria-label="Retour à la page précédente"
            >
              <img src={FlecheRetour} alt="" />
            </button>  
        <h1 className="h1 w-full">Nouveau Transfert</h1>
</div>

        <div className="flex justify-between  w-full">
          {nomstep.map((item, index) => (
            <StepTransfert
              key={index}
              nomStep={item}
              numStep={index + 1}
              isActive={index <= numStep}
              lastStep={index < 2 ? true : false}
              isComplete={numStep > index}
              setNumStep={setNumStep}
            />
          ))}
        </div>
       <div className=' sm:px-0 w-full '>

        {numStep === 0 && (
          <Montant
            euroValue={amountToSend}
            setEuroValue={(value) => setAmountToSend(value)}
            dinarValue={amountToReceive}
            setDinarValue={(value) => setAmountToReceive(value)}
            setCurrencyToTND={(value) => setCurrencyToTND(value)}
            com={com}
            setCom={(value) => setCom(value)}
            taux={taux}
            setTaux={(value) => setTaux(value)}
            setDepartureCurrencyId={(value) => setDepartureCurrencyId(value)}
            setDestinationCurrencyId={(value) => setDestinationCurrencyId(value)}
            setNumStep={setNumStep}
            paymentMode={paymentMode}
            setPaymentMode={(value) => setPaymentMode(value)}
            promoCode={promoCode}
            setPromoCode={(value) => setPromoCode(value)}
            pathCode={pathCode}
            valuePays={valuePays}
            setValuePays={(value) => setValuePays(value)}
            functionTracks={functionTracks}

          />
        )}


        {numStep === 1 && (
          <Benefiaire
            paysCode={TransferData?.codeIso || ''}
            setBenificiareId={(value) => setBenificiareId(value)}
            motif={motif}
            setMotif={(value) => setMotif(value)}
            setNumStep={setNumStep}
            setIdBeneficiary={(value) => setIdBeneficiary(value)}
            // apiData={partnersData}
            idBeneficiary={idBeneficiary}
            // setColectPointId={(value) => setColectPointId(value)}
            // colectPointId={colectPointId}
            setSelectedBnfList={(value) => setSelectedBnfList(value)}
            selectedBnfList={selectedBnfList}
            // selectedOperateur={selectedOperateur}
            // setSelectedOperateur={setSelectedOperateur}
            valuePays={valuePays}
            functionTracks={functionTracks}
            pathCode={pathCode}
            isWallet={true}
            // setOpenModalWallet={setOpenModalWallet}
            // selectedValue={selectedValue}
          />
        )}


         {numStep === 2 && (
          <Paiement
            departureCurrencyId={departureCurrencyId}
            destinationCurrencyId={destinationCurrencyId}
            amountD={amountToSend}
            currencyToTND={amountToReceive}
            modePay={modePay}
            com={com}
            totalSend={Number(amountToSend) + Number(com)}
            benificiareId={benificiareId}
            motif={motif}
            // colectPointId={colectPointId}
            senderId={user?.user?._id}
            token={user?.token?.accessToken}
            taux={taux}
        
            paymentMode={paymentMode}
          
            promoCode={promoCode}
            valuePays={valuePays.value}
            functionTracks={functionTracks}
          />
        )}
     

      </div>
      </div>
         <div className="  xl:hidden fixed bottom-0 mb-[100px] right-0 ">
        <Synthese
          text="Total à payer"
          LabelMantantToSend="Montant à envoyer"
          mantantToSend={amountToSend}
          labelTaux="Taux de change"
          taux={taux}
          labelCom="Commission"
          com={com}
          LabelMantantToRecu="Montant à recevoir"
          // mantantToRecu={euroValue * com}
          mantantToRecu={amountToReceive}

          valuePays={valuePays}
        />
      </div>
      
    </div>
  )
}

export default TransfertWallet
